import styled from 'styled-components';
import RadioInput from 'js/components/core/form/RadioInput';

export default styled(RadioInput)`
  padding: 1.25rem 1rem;
`;
